function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo } from 'react';
import { Button } from 'native-base';
export default /*#__PURE__*/memo(_ref => {
  let {
    variant = 'solid',
    size = 'lg',
    colorScheme = 'primary',
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Button, _extends({
    variant: variant,
    colorScheme: colorScheme,
    size: size,
    textTransform: "uppercase",
    accessibilityRole: "button"
  }, rest), children);
});
//# sourceMappingURL=Button.js.map